import { environment } from "../../environments/environment";

export class Constantes {

	// Variables dinámicas para Logo y otros
	static LOGO: string = environment.logo;
	static TITULO_LOGO: string = environment.tituloLogo;
	static TITLE: string = environment.title;
	static ICON: string = environment.icon;
	static COLOR_TOPBAR: string = environment.colorTopBar;
	static LOGO_TOPBAR: string = environment.logoTopBar;

	// Roles
	static readonly SUPER_ADMINISTRADOR = 'SUPER_ADMINISTRADOR';
	static readonly ADMINISTRADOR_ENTIDAD = 'ADMINISTRADOR_ENTIDAD';
	static readonly GESTOR_ESPACIOS = 'GESTOR_ESPACIOS';
	static readonly GESTOR_CONTENIDO = 'GESTOR_CONTENIDO';
	static readonly SOLO_NOTIFICACIONES = 'SOLO_NOTIFICACIONES';
	static readonly GESTOR_CONTENIDO_SOLO_LECTURA = 'GESTOR_CONTENIDO_SOLO_LECTURA';

	static readonly CIUDADANO = 'CIUDADANO';

	static readonly DIAS_PROXIMOS_EXPIRAR = 30;

	// AVISO (Notificacion)
	// 0.- Instantanea, 1.- Programada
	static readonly NOTIFICACION_INSTANTANEA = 0;
	static readonly NOTIFICACION_PROGRAMADA = 1;

	// Tipos Programados 0.- Entrando, 1.- Saliendo
	static readonly ENVIAR_AL_ENTRAR = 0;
	static readonly ENVIAR_AL_SALIR = 1;

	// Tipos Instantaneoss
	static readonly ESTAN_AHORA = 2;
	static readonly VISITADO_ALGUNA_VEZ = 3;
	static readonly EXPLORADO_ALGUNA_VEZ = 4;
	static readonly TIENEN_LA_APP = 5;

	// Guias

	static readonly Guia_de_Refencia_de_estilos = environment.urlPublicacionFija + '/assets/itsoft/guias/Guia_de_Refencia_de_estilos.pdf';
	static readonly Guia_de_Refencia_de_estilos_tipotolia =  environment.urlPublicacionFija + '/assets/itsoft/guias/Guia_de_Refencia_de_estilos_tipotolia.pdf';
	static readonly Tipologia_Plantilla =  environment.urlPublicacionFija + '/assets/itsoft/guias/tipologia-plantilla.svg';
	static readonly Guia_de_Refencia_de_exportacion = environment.urlPublicacionFija + '/assets/itsoft/guias/Plantilla_Importar_Contenido.xlsx';


	// ACTIVOS
	static readonly TIPO_LOCALIZACION_ACTIVOS = {
		ESTATICO:  0,
		DIRECTA: 1,
		INDIRECTA: 2
	};

	// AUTORIZADO POR UBICACION
	static readonly VISIBLE_SI_UBICADO_EN =
	{
		SIEMPRE: 0,
		ESPACIO: 1,
		SECCION: 2,
		NODO: 3
	};

	// VALORES POR DEFECTO
	static readonly MAX_PESO = 2147483647;
	static readonly PESO_DEFAULT = 999999;
	static readonly PESO = 100;
	static readonly X_COORDENADA = -999999;
	static readonly Y_COORDENADA = -999999;
	static readonly ZOOM_MINIMO = 1;
	static readonly ZOOM_MAXIMO = 5;
	
	//Tipo Foto
	static readonly TIPO_FOTO =
        {
            PRINCIPAL: 0,
            CARRUSEL: 1
        }

	static readonly AZUL = 'rgba(0,172,255,1)';
	static readonly VERDE = 'rgba(64, 255, 0, 1)';
	static readonly HOVER = 'rgba(150, 255, 115, 0.5)';

	// nodoPlano
	static readonly nodoSymbolStroke = 'rgba(120,120,120,1)';
	static readonly nodoSymbolFill = 'rgba(255,255,255,0.5)';
	static readonly nodoSymbolStrokeWidth = '2';

	static readonly nodoSectionHoverFill = 'rgba(255,255,0,1)';
	static readonly nodoSectionHoverStroke = 'rgba(0,196,0,0.5)';

	static readonly nodoSymbolSize = 35;
	static readonly nodoIconHeight = '150';
	static readonly nodoIconWidth = '150';

	static readonly nodosymbolHoverStroke = 'rgba(150, 255, 115, 0.5)';
	static readonly nodosymbolHoverFill  = 'rgba(150, 255, 115, 0.5)';

	static readonly nodoSymbolStroke_SELECT = 'rgba(64, 255, 0,1)';
	static readonly nodoSymbolFill_SELECT = 'rgba(64, 255, 0,0.5)';
	static readonly nodoSymbolStrokeWidth_SELECT = '4';
	static readonly nodoSectionHoverFill_SELECT = 'rgba(64, 255, 0,0,1)';
	static readonly nodoSectionHoverStroke_SELECT = 'rgba(64, 255, 0,0.5)';
	static readonly nodoSymbolSize_SELECT = 35;
	static readonly nodoIconHeight_SELECT = '150';
	static readonly nodoIconWidth_SELECT= '150';


	static readonly nodoBeconAsociadoHoverFill = 'rgba(255,255,0,0.8)';
	static readonly nodoBeconAsociadoHoverStroke = 'rgba(0,196,0,0.25)';
// seccionPlano

	// Relleno Seccion
	static readonly seccionFill = 'rgba(184,219,184,0.4)'; 				// Reposo
	static readonly seccionHoverFill = 'rgba(150, 255, 115, 0.4)'; 		// Hover
	static readonly seccionFill_SELECT = 'rgba(64, 255, 0,0.5)';		// Select

	// Arista Seccion
	static readonly seccionStroke = 'rgba(184,219,184,0.4)'; 				// Reposo
	static readonly seccionHoverStroke = 'rgba(64, 255, 0, 0.4)';			// Hover
	static readonly seccionStroke_SELECT = 'rgba(64, 255, 0, 0.4)';		// Select

	// Ancho
	static readonly seccionStrokeWidth = '5'; 							// Reposo
	static readonly seccionStrokeWidth_SELECT = '5';					// Select

	// ¿?¿?¿?
	static readonly seccionHoverFill_SELECT = 'rgba(64, 255, 0, 0, 1)';
	static readonly seccionHoverStroke_SELECT = 'rgba(64, 255, 0, 0.5)';

// conexionPlano
	static readonly conexionFill  = 'rgba(0,172,255,1)';
	static readonly conexionStroke   = 'rgba(0,172,255,1)';
	static readonly conexionStrokeWidth   = '10';

	static readonly conexionsymbolHoverStroke = 'rgba(150, 255, 115, 0.5)';
	static readonly conexionsymbolHoverFill  = 'rgba(150, 255, 115, 0.5)';

	static readonly conexionsymbolHoverStroke_SELECT = 'rgba(150, 255, 115, 0.5)';
	static readonly conexionsymbolHoverStroke_CORTADO = 'rgba(150, 255, 115, 0.5)';

	static readonly conexionFill_SELECT  = 'rgba(64, 255, 0, 1)';
	static readonly conexionStroke_SELECT   = 'rgba(64, 255, 0, 1)';
	static readonly conexionStrokeWidth_SELECT   = '15';

	static readonly conexionFill_CORTADO  = 'rgba(255,128,128,1)';
	static readonly conexionStroke_CORTADO   = 'rgba(255,128,128,1)';
	static readonly conexionStrokeWidth_CORTADO   = '10';

// contenidoPlano
	static readonly contenidoSymbolStroke = 'rgba(0,0,0,0)';
	static readonly contenidoSymbolFill = 'rgba(0,0,0,0)';
	static readonly contenidoSymbolStrokeWidth = '5';
	static readonly contenidoSymbolSize = 45;
	static readonly contenidoSectionHoverFill = 'rgba(255,255,0,0.5)';
	static readonly contenidoSectionHoverStroke = 'rgba(0,196,0,0.5)';
	static readonly contenidoIconHeight = '100';
	static readonly contenidoIconWidth = '100';

	static readonly contenidosymbolHoverStroke = 'rgba(150, 255, 115, 0.5)';
	static readonly contenidosymbolHoverFill  = 'rgba(150, 255, 115, 0.5)';

	static readonly contenidoSymbolStroke_SELECT = 'rgba(64, 255, 0,1)';
	static readonly contenidoSymbolFill_SELECT = 'rgba(64, 255, 0,0.5)';
	static readonly contenidoSymbolStrokeWidth_SELECT = '4';
	static readonly contenidoSymbolSize_SELECT = 45;
	static readonly contenidoSectionHoverFill_SELECT = 'rgba(255,255,0,0.5)';
	static readonly contenidoSectionHoverStroke_SELECT = 'rgba(0,196,0,0.5)';
	static readonly contenidoIconHeight_SELECT = '100';
	static readonly contenidoIconWidth_SELECT = '100';
	// static readonly iconAlignBottomRight = 'bottom-right';
	static readonly labelColor = 'black';
	static readonly labelFontFamily = 'sans-serif';
	static readonly labelTextLeft = 'left'; // 'middle';
	static readonly labelTextMiddle = 'middle'; // 'middle';
	static readonly labelFontSize = '40px';

	static readonly top_left = 'top-left';
	static readonly top_center = 'top-center';
	static readonly top_right = 'top-right';
	static readonly center_left = 'center-left';
	static readonly center_center = 'center-center';
	static readonly center_right = 'center-right';
	static readonly bottom_left = 'bottom-left';
	static readonly bottom_center = 'bottom-center';
	static readonly bottom_right = 'bottom-right';

	// Colores Secciones Historicos
	static readonly White	= 'rgb(255, 255, 255, 0.8)';
	static readonly Silver	= 'rgb(192, 192, 192, 0.8)';
	static readonly Gray	= 'rgb(128, 128, 128, 0.8)';
	static readonly Black	= 'rgb(0, 0, 0, 0.8)';
	static readonly Red		= 'rgb(255, 0, 0, 0.8)';
	static readonly Maroon	= 'rgb(128, 0, 0, 0.8)';
	static readonly Yellow	= 'rgb(255, 255, 0, 0.8)';
	static readonly Olive	= 'rgb(128, 128, 0, 0.8)';
	static readonly Lime	= 'rgb(0, 255, 0, 0.8)';
	static readonly Green	= 'rgb(0, 128, 0, 0.8)';
	static readonly Aqua	= 'rgb(0, 255, 255, 0.8)';
	static readonly Teal	= 'rgb(0, 128, 128, 0.8)';
	static readonly Blue	= 'rgb(0, 0, 255, 0.8)';
	static readonly Navy	= 'rgb(0, 0, 128, 0.8)';
	static readonly Fuchsia	= 'rgb(255, 0, 255, 0.8)';
	static readonly Purple	= 'rgb(128, 0, 128, 0.8)';
	static readonly LightBlue = 'rgb(16, 154, 200, 0.8)';
	static readonly LightBlue2 = 'rgb(16, 154, 200, 0.2)';


}




// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/constantes.ts